import {backend, fetchBase, Geo} from '../lib/backend';
import {ColumnDef, Report} from '../lib/types';
import {mapObjectOntoTableauStruct} from '../lib/utils';

const columns: ColumnDef[] = [
    {
        name: "equipment_id",
        type: tableau.dataTypeEnum.string,
        alias: "Machine ID",
        description: "Machine unique identifier"
    },
    {
        name: "number_plate",
        type: tableau.dataTypeEnum.string,
        alias: "Machine plate number",
        description: "Machine number plate"
    },
    {
        name: "equipment_model",
        type: tableau.dataTypeEnum.string,
        alias: "Machine Model",
        description: "Machine Model"
    },
    {
        name: "custom_id",
        type: tableau.dataTypeEnum.string,
        alias: "Machine Custom ID",
        description: "Machine Custom ID"
    },

    {
        name: "date",
        type: tableau.dataTypeEnum.date,
        alias: "Date (DD-MM-YYYY)",
        description: "Date"
    },
    {
        name: "telematics_hours",
        type: tableau.dataTypeEnum.float,
        alias: "Telematics Hours",
        description: "Telematics Hours"
    }
];

const getReport = async () => {

    const connectionData_1 = tableau.connectionData ? JSON.parse(tableau.connectionData) : {};
    const geo = (connectionData_1.geo || "uae") as Geo;
    const account = (connectionData_1.account || "");

    const url = `/app/reports/sync?report_type=json`;

    let equipments = await backend.getEquipmentsByAccount({
        accountId: account,
        limit: 500,
    }, tableau.password, geo);

    let body = {
        "equipmentIds": equipments.map(a => a.id),
        "startDate": new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7)).toString(),
        "endDate": new Date().toString(),
        "reportType": "Timesheet",
        "formatType": "json",
        "projectId": "",
        "summary": false
    }
    var myHeaders = { "Content-Type": "application/json" };

    const options: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(body)
    };

    let res = await fetchBase(url, options, tableau.password, geo);
    return mapObjectOntoTableauStruct(res, columns);
}

export const timesheet_report: Report = {
    id: 'timesheetReport7Days',
    alias: 'Timesheet Report (7 Days)',
    columns,
    get: getReport,

};
